import { render, staticRenderFns } from "./CategoryTab.vue?vue&type=template&id=c1742442"
import script from "./CategoryTab.vue?vue&type=script&lang=js"
export * from "./CategoryTab.vue?vue&type=script&lang=js"
import style0 from "./CategoryTab.vue?vue&type=style&index=0&id=c1742442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports